import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import axios from "axios";
import { Alert, Form, Input, Modal, TimePicker } from "antd";
import { axiosErrorHandler, isConcurrentModificationError } from "../../../../swzutils";
import dayjs, { Dayjs } from "dayjs";
import DateRangePicker from "../../components/DateRangePicker";
const ConsignmentReviseDeliveryTimeModal = ({ open, consignmentId, consignmentVersion, deliveryFrom, deliveryTo, revisedDeliveryTo, disableDeliveryDateTime, onUpdated, onCancel }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    useEffect(() => {
        if (open) {
            // Force comment revision by clearing them with every change.
            form.setFieldValue("revisedDeliveryComments", null);
        }
    }, [open]);
    const reviseDeliveryTime = (deliveryFrom, deliveryTo, revisedDeliveryToTime, comments) => {
        setLoading(true);
        const revisedDeliveryTo = (revisedDeliveryToTime == null) ? null :
            revisedDeliveryToTime.date(deliveryTo.date()).month(deliveryTo.month()).year(deliveryTo.year());
        axios.patch(`/admin/v1/consignments/${consignmentId}`, {
            deliveryFrom: deliveryFrom.toISOString(),
            deliveryTo: deliveryTo.toISOString(),
            revisedDeliveryTo,
            clearRevisedDeliveryTo: (revisedDeliveryTo == null),
            revisedDeliveryComments: comments,
            version: consignmentVersion
        }).then(response => {
            onUpdated(response.data);
        }).catch(error => {
            if (isConcurrentModificationError(error)) {
                setErrorMessage("The delivery date could not be updated. This is because another user has updated the same consignment.  Please refresh the consignment list and try again.");
            }
            else {
                axiosErrorHandler(error, setErrorMessage);
            }
        }).finally(() => setLoading(false));
    };
    const onFinish = (formValues) => {
        reviseDeliveryTime(formValues.delivery[0], formValues.delivery[1], formValues.revisedDeliveryTo, formValues.revisedDeliveryComments);
    };
    return (_jsx(Modal, { title: "Revise Delivery Time", open: open, onOk: form.submit, onCancel: onCancel, destroyOnHidden: true, confirmLoading: loading, children: _jsxs(Form, { layout: "vertical", form: form, onFinish: onFinish, children: [errorMessage &&
                    _jsx(Alert, { type: "error", title: errorMessage, banner: true }), _jsx(Form.Item, { name: "delivery", label: "Delivery Date/Time", initialValue: (deliveryFrom && deliveryTo)
                        ? [dayjs(deliveryFrom), dayjs(deliveryTo)]
                        : [], rules: [{
                            required: true,
                            message: 'Please enter a delivery time',
                        }], children: _jsx(DateRangePicker, { allowClear: true, disabled: disableDeliveryDateTime }) }), _jsx(Form.Item, { name: "revisedDeliveryTo", label: "Revised Delivery End Time", initialValue: revisedDeliveryTo ? dayjs(revisedDeliveryTo) : null, children: _jsx(TimePicker, { allowClear: true, format: "HH:mm", placeholder: "End Time" }) }), _jsx(Form.Item, { name: "revisedDeliveryComments", label: "Revised Delivery Comments", rules: [
                        { required: true, message: 'Please enter a comment for this change' },
                        { max: 500, message: 'Please limit the comments to 500 characters.' }
                    ], children: _jsx(Input.TextArea, { rows: 2 }) })] }) }));
};
export default ConsignmentReviseDeliveryTimeModal;
